export const mapPostRequestParams = (entityId, params) => {
  return {
    headers: getHeadersParams(entityId),
    method: "POST",
    data: params,
  };
};

export const mapGetRequestParams = (params) => {
  let resParams = "?";
  const keys = Object.keys(params);
  keys.forEach((key) => {
    resParams += `${key}=${params[key]}&`;
  });

  return resParams;
};

export const mapGetRequestHeaders = (entityId) => {
  return {
    headers: getHeadersParams(entityId),
    method: "GET",
  };
};

const getHeadersParams = (entityId) => {
  const token = $('meta[name="csrf-token"]').attr("content");
  return {
    Accept: "application/json",
    "Content-Type": "application/json",
    "ENTITY-ID": entityId,
    "X-CSRF-Token": token,
  };
};
